import { SearchIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { AppDataActions, BaseSauce, PizzaType } from 'misc/enums';
import React, { FC, SyntheticEvent } from 'react';

import { ButtonClearFilter } from 'components/listing';
import { useAppDataContext } from 'misc/appDataCtxt';

interface Props {
  openDrawer: () => void;
}

export const Filters: FC<Props> = ({ openDrawer }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { dispatch, state } = useAppDataContext();

  const onSelectPizzaSauce = (e: SyntheticEvent, base: BaseSauce) => {
    e.preventDefault();

    base === state.filter?.base
      ? dispatch({
          type: AppDataActions.resetFilterPizzaBase,
        })
      : dispatch({
          type: AppDataActions.updateFilter,
          value: {
            filter: {
              base: base,
            },
          },
        });
  };

  const onSelectTypeOfPizza = (e: SyntheticEvent, type: PizzaType) => {
    e.preventDefault();
    dispatch({
      type: AppDataActions.resetFilterIngredients,
    });

    type === state.filter?.pizzaType
      ? dispatch({
          type: AppDataActions.resetFilterPizzaType,
        })
      : dispatch({
          type: AppDataActions.updateFilter,
          value: {
            filter: {
              pizzaType: type,
            },
          },
        });
  };

  const onSelectIngredients = () => {
    dispatch({
      type: AppDataActions.resetFilterPizzaType,
    });

    openDrawer();
    onClose();
  };

  return (
    <>
      <Button
        leftIcon={<SearchIcon />}
        onClick={onOpen}
        variant="outline"
        backgroundColor={'whiteAlpha.800'}
        colorScheme={'red'}
        borderRadius={50}
        shadow={'2xl'}
        size={'md'}
        m={2}
      >
        Trouver sa pizza
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="sm">
        <ModalOverlay backdropFilter="auto" backdropBlur="sm" />

        <ModalContent>
          <ModalHeader>Assistant de choix de Pizza</ModalHeader>

          <ModalCloseButton />

          <ModalBody py={6}>
            <Stack gap={8}>
              <Flex direction={'row'} justifyContent={'space-between'}>
                <Stack gap={2}>
                  <Text>Base :</Text>
                  <Button
                    colorScheme="gray"
                    shadow={'md'}
                    isActive={state.filter?.base === BaseSauce.tomato}
                    onClick={(e: SyntheticEvent) =>
                      onSelectPizzaSauce(e, BaseSauce.tomato)
                    }
                  >
                    🍅 Tomate
                  </Button>
                  <Button
                    colorScheme="gray"
                    shadow={'md'}
                    isActive={state.filter?.base === BaseSauce.creme}
                    onClick={(e: SyntheticEvent) =>
                      onSelectPizzaSauce(e, BaseSauce.creme)
                    }
                  >
                    🥛 Crème
                  </Button>
                </Stack>

                <Stack gap={2}>
                  <Text>Préférence :</Text>
                  <Button
                    colorScheme="gray"
                    shadow={'md'}
                    isActive={state.filter?.pizzaType === PizzaType.vegetarian}
                    onClick={(e: SyntheticEvent) =>
                      onSelectTypeOfPizza(e, PizzaType.vegetarian)
                    }
                  >
                    🥦 Végétarien
                  </Button>
                  <Button
                    colorScheme="gray"
                    shadow={'md'}
                    isActive={state.filter?.pizzaType === PizzaType.carnivor}
                    onClick={(e: SyntheticEvent) =>
                      onSelectTypeOfPizza(e, PizzaType.carnivor)
                    }
                  >
                    🥩 Carnivore
                  </Button>
                  <Button
                    shadow={'md'}
                    leftIcon={<SearchIcon />}
                    isActive={
                      state.filter?.ingredients &&
                      state.filter.ingredients.length > 0
                    }
                    onClick={() => onSelectIngredients()}
                  >
                    ingrédients
                  </Button>
                </Stack>
              </Flex>

              <Flex justifyContent={'space-evenly'} alignItems={'center'}>
                <ButtonClearFilter />
                <Button shadow={'md'} onClick={onClose}>
                  Filtrer
                </Button>
              </Flex>
            </Stack>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
